export default {
  placeholder: 'Быстрый поиск по названию или ID шаблона',
};
